var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrollToTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "url(#paint0_linear_235_4073)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 45C33.75 45.6904 34.3096 46.25 35 46.25C35.6904 46.25 36.25 45.6904 36.25 45L33.75 45ZM35.8839 24.1161C35.3957 23.628 34.6043 23.628 34.1161 24.1161L26.1612 32.0711C25.673 32.5592 25.673 33.3507 26.1612 33.8388C26.6493 34.327 27.4408 34.327 27.9289 33.8388L35 26.7678L42.0711 33.8388C42.5592 34.327 43.3507 34.327 43.8388 33.8388C44.327 33.3507 44.327 32.5592 43.8388 32.0711L35.8839 24.1161ZM36.25 45L36.25 25L33.75 25L33.75 45L36.25 45Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_4073",
    x1: 19.3304,
    y1: -29.7563,
    x2: 103.631,
    y2: 15.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#624FD1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTop);
export default __webpack_public_path__ + "static/media/scrollToTop.1cecec59.svg";
export { ForwardRef as ReactComponent };